export default {
  baseURL: 'https://api.frontm.ai',
  filesAPI: 'https://gw.frontm.ai/proxy/resource',
  contentURL: 'https://gw.frontm.ai/proxy/botLogos/',
  botFilesAPI: 'https://gw.frontm.ai/proxy/resource/botfile?path=',
  paymentGatewayKey: "pk_live_Oyu2NEXa9MmN6Kq0POcBHz9J",
  soundURL: 'https://gw.frontm.ai/proxy/sounds/',
  gRPCURL: 'https://gw.frontm.ai',
  webertcSignalServer: 'gw.frontm.ai',
  mapURL: 'https://maps.frontm.ai/styles/klokantech-basic/style.json',
  sipURI: 'frontmsecureweb@pstn-prod.frontm.ai',
  sipPassword: 'frontm@123^%',
  sipWebsocket: 'wss://pstn-prod.frontm.ai:8089/ws',
  TokenSecretKey: "4DjEEHV4feUWpvJARMSAEJ4E7JDOwUtQ7F6YYd21SQMJyM1TPoCjLeFAUe3vpQceWmGRrJRdh1z",
};
